import { Loader2 } from 'lucide-react';

export const AppLoading = () => {
	return (
		<div className="min-h-screen bg-blue-50 flex items-center justify-center">
			<div className="text-center">
				<Loader2 className="h-8 w-8 text-blue-600 animate-spin mx-auto mb-4" />
				<p className="text-gray-600 font-medium">Loading...</p>
			</div>
		</div>
	);
};
